// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"20a66bcc","129":"737b98ad","506":"8cd10f14","520":"0f868d24","661":"cfacbc43"}[chunkId] + ".chunk.js";
};